import React from "react";

const RoundMedalsTable = ({ results, selectedRJP }) => {
  return (
    <div>
      <div
        style={{
          width: "100%",
          overflowX: "auto",
          marginTop: "30px",
          marginBottom: "50px",
        }}
      >
        <table className="table my_table competitorTable">
          <tbody>
            <tr className="header-row">
              <td className="text-center p-25-5 w-5">#</td>
              <td className="text-center p-25-5 w-10">Place</td>
              <td className="p-25-5 w-25">Competitor</td>
              <td className="text-center p-25-5 w-50">
                {selectedRJP?.selectedJudge || "-"}
              </td>
            </tr>
            <tr style={{
                  background: "#FFFFFF",
                  fontSize: "14px",
                  height: "40px",
                }}>
              <td></td>
              <td></td>
              <td></td>
              <td className="text-center p-25-5 w-50">{selectedRJP?.round}</td>
            </tr>
            {results?.map((dancer, index) => (
              <tr
                key={index}
                style={{
                  background: "#FFFFFF",
                  fontSize: "14px",
                  height: "40px",
                }}
              >
                <td className="text-center grey-30">{dancer?.card_number}</td>
                <td className="text-center grey-30">{dancer?.placeCount}</td>
                <td className="grey-30">
                  <div>
                    {dancer?.dancerDetail?.fname} {dancer?.dancerDetail?.lname}
                    <div style={{ opacity: "0.5", fontSize: "12px" }}>
                      {dancer?.dancerDetail?.school}
                    </div>
                  </div>
                </td>
                <td className="text-center grey-30">{dancer?.score ?? "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RoundMedalsTable;
